import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetEpaCorrespondenceDetailsAsync,
  IEpaCorrespondenceDetails,
} from "../../api/IEpaCorrespondence";
import { RootState } from "../store";

export interface EpaCorrespondenceState {
  fetchStatus: string;
  epaCorrespondence?: IEpaCorrespondenceDetails;
}

const initialState: EpaCorrespondenceState = {
  fetchStatus: "Loading...",
  epaCorrespondence: undefined,
};

export const loadEpaCorrespondenceAsync = createAsyncThunk(
  "epaCorrespondence/load",
  async (epaCorrespondenceId: string) => {
    const response = await GetEpaCorrespondenceDetailsAsync(
      epaCorrespondenceId
    );
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const epaCorrespondenceSlice = createSlice({
  name: "epaCorrespondence",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadEpaCorrespondenceAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadEpaCorrespondenceAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.epaCorrespondence = action.payload;
      });
  },
});

export const selectEpaCorrespondence = (state: RootState) =>
  state.epaCorrespondence;

export default epaCorrespondenceSlice.reducer;
